import { BrowserRouter, Routes, Route, Outlet } from "react-router-dom";

import Home from "./pages/Home";
import UploadEpaper from "./pages/UploadEpaper";
import ManageEpapers from "./pages/ManageEpapers";
import EpaperViewer from "./pages/EpaperViewer";
import Header from "./components/Header";
import Footer from "./components/Footer";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./context/AuthContext";
import UploadAd from "./pages/UploadAd";
import ManageAds from "./pages/ManageAds";
import ManageEditors from "./pages/ManageEditors";

// Layout for standard pages (Home)
const ClientLayout = () => (
  <div className="flex flex-col min-h-screen">
    <Header />
    <main className="flex-grow">
      <Outlet />
    </main>
    <Footer />
  </div>
);

// Layout for Admin Pages
const AdminLayout = () => (
  <div className="flex flex-col min-h-screen bg-gray-50">
    <Header />
    <main className="flex-grow p-6">
      <Outlet />
    </main>
    <Footer />
  </div>
);

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          
          {/* Client Routes */}
          <Route element={<ClientLayout />}>
            <Route path="/" element={<Home />} />
          </Route>

          {/* Epaper Viewer (Full Screen, No Footer/Header) */}
          <Route path="/viewer/:id" element={<EpaperViewer />} />

          {/* Public Admin Route */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Protected Admin Routes */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AdminLayout />}>
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
              <Route path="/admin/upload" element={<UploadEpaper />} />
              <Route path="/admin/manage" element={<ManageEpapers />} />
              <Route path="/admin/upload-ad" element={<UploadAd />} />
              <Route path="/admin/manage-ads" element={<ManageAds />} />
              <Route path="/admin/editors" element={<ManageEditors />} />
            </Route>
          </Route>

        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;